import { FC } from "react"
import { Alert, CircularProgress } from "@mui/material"
import { useParams } from "react-router-dom"
import { UserbotPage } from "./userbotPage"
import { TemplateRunForm } from "../components"
import { useTemplateQuery } from "../store"
import { getApiErrorMessage } from "@/core/utils"

export const TemplateRunPage: FC = () => {
  const { id } = useParams<{ id: string }>()
  const { data, isFetching, isError, error } = useTemplateQuery(
    { id: id! },
    { skip: !id },
  )

  return (
    <UserbotPage title="Запуск шаблона">
      {isFetching && !data && <CircularProgress />}
      {isError && <Alert severity="error">{getApiErrorMessage(error)}</Alert>}
      {data && <TemplateRunForm template={data} />}
    </UserbotPage>
  )
}
